import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		subheader: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			marginTop: theme.spacing(4),
			marginBottom: theme.spacing(2),
		},
		overdueText: {
			color: theme.palette.error.main,
			fontSize: 24,
			fontWeight: 700,
			lineHeight: "32px",
		},
		normalText: {
			color: theme.palette.custom.textPrimary,
			fontSize: 24,
			fontWeight: 700,
			lineHeight: "32px",
		},
		overdueIcon: {
			width: 20,
			height: 20,
			color: theme.palette.error.main,
		},
	} satisfies Record<string, CSSObject>);
